import React from 'react';
import { Form, Input } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { notifyError } from '@nutastic/nutastic-react-app';

const componentClass = 'registerPasswordForm';

export const RegisterPassword = ({ emailToShow, onComplete, onCancel }) => {
    const initialCredential = {
        email: emailToShow,
        password: '',
        passwordConfirm: ''
    };

    const onRegisterClick = ({ password, passwordConfirm }) => {
        if (!password || password.length < 7 || password !== passwordConfirm) {
            notifyError('registrationError', 'Bad Password', 'The passwords you entered must match and be 7 characters or more.');
        } else {
            onComplete(password);
        }
    };

    return <div>
        <div className={`${componentClass}__message`}>
            <h2>Set Your Password</h2>
            <p>Enter a password below that you would like to use for your NuStation account. Remember to <b>keep track of your password</b>.</p>
        </div>
        <Form layout="vertical" name="login-form" initialValues={initialCredential} onFinish={onRegisterClick}>
            <Form.Item name="email" label="email" initialValue={emailToShow}>
                <Input prefix={<MailOutlined className="text-primary"/>} disabled={true}/>
            </Form.Item>
            <Form.Item
                name="password"
                label="Password"
                rules={[
                    {
                        required: true,
                        message: 'Please input your password'
                    }
                ]}
            >
                <Input.Password prefix={<LockOutlined className="text-primary"/>} placeholder="Enter password"/>
            </Form.Item>
            <Form.Item
                name="passwordConfirm"
                label="Confirm Your Password"
                rules={[
                    {
                        required: true,
                        message: 'Please re-enter the password entered above to confirm'
                    }
                ]}
            >
                <Input.Password prefix={<LockOutlined className="text-primary"/>} placeholder="Confirm password"/>
            </Form.Item>
            <Form.Item className="mt-5">
                <button type="submit" className="btn btn-primary btn-block">Continue</button>
            </Form.Item>
            { onCancel && <div className="linkTextButton mt-5" onClick={onCancel}>Go Back</div> }
        </Form>
    </div>;
};

export default RegisterPassword;
